import { useLanguage } from '../../contexts/LanguageContext';

export default function EditableStringListCard({ title, items = [], onChange, placeholder }) {
  const { t } = useLanguage();

  const handleTextChange = (index, text) => {
    const next = [...items];
    next[index] = text;
    onChange(next);
  };

  const handleAdd = () => {
    onChange([...items, '']);
  };

  const handleRemove = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };

  return (
    <div className="card-surface w-full p-4">
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
        <button
          type="button"
          onClick={handleAdd}
          className="text-xs font-semibold text-primary"
        >
          + {t('add')}
        </button>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-gray-500">{placeholder || t('noneListed')}</p>
      ) : (
        <ul className="space-y-2">
          {items.map((item, index) => (
            <li key={`${title}-${index}`} className="flex items-start gap-2">
              <input
                type="text"
                value={item}
                onChange={(e) => handleTextChange(index, e.target.value)}
                className="flex-1 rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-primary focus:outline-none"
              />
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="rounded-lg px-2 py-2 text-xs font-medium text-critical"
              >
                {t('remove')}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
